import { Form } from 'formik';
import { EditTreatmentOverviewFormAttributesStep } from './EditTreatmentOverviewFormAttributesStep';
import { EditTreatmentOverviewFormExplanationsStep } from './EditTreatmentOverviewFormExplanationsStep';
import { EditTreatmentOverviewFormData } from '~/lib/types/notes/EditTreatmentOverviewFormData';

export enum TreatmentOverviewFormStep {
  AttributesStep = 0,
  ExplanationsStep = 1,
}

export type EditTreatmentOverviewFormProps = {
  step: TreatmentOverviewFormStep;
  oldValues: EditTreatmentOverviewFormData;
};

export const EditTreatmentOverviewForm = ({
  step,
  oldValues,
}: EditTreatmentOverviewFormProps) => (
  <Form>
    {step === TreatmentOverviewFormStep.AttributesStep && (
      <EditTreatmentOverviewFormAttributesStep />
    )}
    {step === TreatmentOverviewFormStep.ExplanationsStep && (
      <EditTreatmentOverviewFormExplanationsStep oldValues={oldValues} />
    )}
  </Form>
);
